<script lang="ts">
    import Login from '../components/Login.svelte';
    import { _ } from 'svelte-i18n';
    import { settingsStore, refreshSettings } from '../stores/settings';
    import { onMount } from 'svelte';

    let isLoggedIn = false;
    let username = '';
    let returnTo = "/game-assist/";
    
    onMount(async () => {

        // Force refresh settings to ensure we have the latest auth state
        await refreshSettings();

        isLoggedIn = !!$settingsStore?.user?.id;
        username = $settingsStore?.user?.username || $_('login.anonymousUser');
        
        // console.log('isLoggedIn', isLoggedIn);
        // console.log('username', username);
        
        // Parse parameters from hash-based routing
        const hash = window.location.hash;
        let urlParams = new URLSearchParams();
        
        // Extract query string from hash (e.g., #/login?param=value)
        const hashParts = hash.split('?');
        if (hashParts.length > 1) {
            // Join all parts after the first '?' in case there are multiple '?' in the URL
            const queryString = hashParts.slice(1).join('?');
            urlParams = new URLSearchParams(queryString);
        }
                
        // Get return_to parameter
        const queryReturnTo = urlParams.get('return_to');
        
        if (queryReturnTo && queryReturnTo !== '/') {
            console.log('queryReturnTo from hash', queryReturnTo);
            // Ensure it's a relative path by removing any protocol and domain
            returnTo = queryReturnTo.replace(/^(?:https?:)?(?:\/\/[^\/]+)?(\/.*)?$/, '$1');
        }
        
        console.log('Final returnTo:', returnTo);

    });

</script>

<div class="container pt-6">
    {#if isLoggedIn}
        <div class="logged-in-message">
            <h2 class="brand-font">{$_('login.welcomeBack')}</h2>
            <p>{$_('login.alreadyLoggedIn', { values: { username: username } })}</p>
            <a role="button" href={returnTo} class="button">{$_('login.continue')}</a>
        </div>
    {:else}
        <Login {returnTo}/>
    {/if}
</div>

<style>
    .logged-in-message {
        text-align: center;
        margin: 3rem auto;
        padding: 2rem;
        max-width: 500px;
    }
</style> 